import type { FC } from 'react';

type IconProps = {
    className?: string;
};

/**
 * 左矢印アイコン
 */
export const ArrowLeftIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M19 12H5M5 12l6-6m-6 6l6 6"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

